import { OverlayTrigger, Tooltip } from "react-bootstrap";

const CustomizedYAxisTick = ({ x, y, payload }) => {
    const maxLength = 20;
    const fullText = payload.value;
    const truncatedText =
        fullText.length > maxLength ? fullText.slice(0, maxLength) + '…' : fullText;

    const tooltipResult = (
        <Tooltip className='agent-tooltip'>
            {fullText}
        </Tooltip>
    );
    return (
        <OverlayTrigger placement="top" overlay={tooltipResult}>
            <g transform={`translate(${x},${y})`}>
                <text
                    x={0}
                    y={50}
                    dy={4}
                    textAnchor="end"
                    fill="#333"
                    fontSize={12}
                    style={{ pointerEvents: 'auto', cursor: 'default' }}
                >
                    {truncatedText}
                </text>
            </g>
        </OverlayTrigger>
    );
};
export default CustomizedYAxisTick;